<div class="row">
  <div class="col-12 col-md-6">
    @if (taskOrQuote) {
      <ng-select
        class="custom"
        required
        [searchable]="false"
        [items]="priorityTypeOptions"
        placeholder="Select an Option"
        [selectOnTab]="true"
        name="priorityTypeOption"
        bindLabel="name"
        [(ngModel)]="selectedPriorityTypeOption"
        (change)="onPriorityTypeSelection()"
        [disabled]="!isEditable"
        >
      </ng-select>
    }
  </div>
  @if (selectedPriorityTypeOption) {
    @if (selectedPriorityTypeOption.hasCalculatedPriority) {
      @if (shouldShowStartDateForCalculated()) {
        <div class="col-12 col-md-6">
          <p-datepicker
            [style]="{'width': '100%'}"
            name="dueDateStart"
            class="priority-calendar-picker"
            required
            [placeholder]="'Start Date'"
            [(ngModel)]="taskOrQuote.dueDateStart"
            [inputStyle]="{'width':'100%'}"
            [disabled]="!isEditable"
            [maxDate]="taskOrQuote.dueDateEnd"
            oninput="validity.valid||(value='');"
            [showButtonBar]="true"
            (ngModelChange)="this.calculatedDatesChanged()"
            (onChange)="this.calculatedDatesChanged()"
            (change)="this.calculatedDatesChanged()">
          </p-datepicker>
        </div>
      }
      @if (shouldShowEndDateForCalculated()) {
        <div class="col-12 col-md-6">
          <p-datepicker
            [style]="{'width': '100%'}"
            appendTo="body"
            [baseZIndex]="20000"
            name="dueDateEnd"
            required
            [placeholder]="'End Date'"
            class="priority-calendar-picker"
            [(ngModel)]="taskOrQuote.dueDateEnd"
            [inputStyle]="{'width':'100%'}"
            [disabled]="!isEditable"
            [minDate]="taskOrQuote.dueDateStart"
            oninput="validity.valid||(value='');"
            [showButtonBar]="true"
            (ngModelChange)="this.calculatedDatesChanged()"
            (onChange)="this.calculatedDatesChanged()"
            (change)="this.calculatedDatesChanged()">
          </p-datepicker>
        </div>
      }
      @if (shouldShowWeeksOut()) {
        <div class="col-12 col-md-6" style="margin: auto 0 auto 0">
          {{selectedPriorityTypeOption.weeksOutStart}} to {{selectedPriorityTypeOption.weeksOutEnd}} Weeks
        </div>
      }
      @if (shouldShowCalculatedWeeksOut()) {
        <div class="col-12 col-md-6" style="margin: auto 0 auto 0">
          {{signedQuoteWeekRangeCalculation.start}} to {{signedQuoteWeekRangeCalculation.end}} Weeks
        </div>
      }
    }
    @if (!selectedPriorityTypeOption.hasCalculatedPriority) {
      <div class="col-12 col-md-6">
        <ng-select
          class="custom"
          [required]="true"
          [searchable]="!taskOrQuote.manualPriorityLevel"
          [selectOnTab]="true"
          [items]="allManualPriorityLevels"
          placeholder="Select a Priority Level"
          name="priorityLevelOption"
          bindLabel="status"
          [(ngModel)]="taskOrQuote.manualPriorityLevel"
          (change)="onPriorityLevelSelection($event)"
          [disabled]="!isEditable">
          <ng-template ng-option-tmp ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div class="littleColorBox" [style.background-color]="item.backgroundColor"></div>
            {{item.status}}
          </ng-template>
        </ng-select>
      </div>
      <div class="col-12 col-md-6">
        @if (taskOrQuote) {
          <p-datepicker
            class=" priority-calendar-picker"
            [style]="{'width': '100%'}"
            appendTo="body"
            [baseZIndex]="20000"
            name="dueDateStart"
            required
            [placeholder]="'Start Date'"
            [(ngModel)]="taskOrQuote.dueDateStart"
            [inputStyle]="{'width':'100%'}"
            [disabled]="!isEditable"
            [maxDate]="taskOrQuote.dueDateEnd"
            oninput="validity.valid||(value='');"
            [showButtonBar]="true"
            (ngModelChange)="this.emitChangedEvent()"
            (onChange)="this.emitChangedEvent()"
            (change)="this.emitChangedEvent()"
            >
          </p-datepicker>
        }
      </div>
      <div class="col-12 col-md-6">
        @if (taskOrQuote) {
          <p-datepicker
            [style]="{'width': '100%'}"
            appendTo="body"
            [baseZIndex]="20000"
            name="dueDateEnd"
            class="left-this priority-calendar-picker"
            required
            [placeholder]="'End Date'"
            [(ngModel)]="taskOrQuote.dueDateEnd"
            [inputStyle]="{'width':'100%'}"
            [disabled]="!isEditable"
            [minDate]="taskOrQuote.dueDateStart"
            oninput="validity.valid||(value='');"
            [showButtonBar]="true"
            (ngModelChange)="this.emitChangedEvent()"
            (onChange)="this.emitChangedEvent()"
            (change)="this.emitChangedEvent()"
            >
          </p-datepicker>
        }
      </div>
    }
    @if (selectedPriorityTypeOption.name == calculatedPriorityType.WeekRange || selectedPriorityTypeOption.name == calculatedPriorityType.DayRange) {
      <div class="col-12">
        <input pInputText #rangeStartInput required name="rangeStart" [(ngModel)]="taskOrQuote.manualRangeStart"/>
        &mdash;
        <input pInputText #rangEndInput required name="rangEnd" [(ngModel)]="taskOrQuote.manualRangeEnd"/>
      </div>
    }
  }
</div>
